import {css} from "@emotion/css";

export const styles = {
  root: css`
    width: 100%;
  `,
};
